import { useParams } from "react-router-dom";
import Communications from "../../components/Communication/Communications";

export default function AdminCommunications() {
  const { id } = useParams();

  return (
    <Communications id={id} userRole={"Admin"} />
  );
}